import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { useI18n } from '../../i18n/I18nProvider';

const TermsAcceptance = ({ checked, onChange, error }) => {
  const { pick } = useI18n();

  return (
    <Wrap>
      <label>
        <input type="checkbox" checked={checked} onChange={onChange} />
        <span>
          {pick('J’accepte les ', 'I accept the ')}
          <Link to="/terms" target="_blank">{pick('conditions d’utilisation', 'terms of use')}</Link>
          {pick(', la ', ', the ')}
          <Link to="/privacy" target="_blank">{pick('politique de confidentialité', 'privacy policy')}</Link>
          {pick(' et le ', ' and the ')}
          <Link to="/review-policy" target="_blank">{pick('fonctionnement des avis vérifiés', 'verified reviews policy')}</Link>.
        </span>
      </label>
      {error ? <small>{error}</small> : null}
    </Wrap>
  );
};

const Wrap = styled.div`
  margin: .35rem 0 .9rem;

  label {
    display: grid;
    grid-template-columns: auto minmax(0,1fr);
    align-items: start;
    gap: .65rem;
    color: #514d47;
    font-size: .78rem;
    line-height: 1.55;
    cursor: pointer;
  }

  input {
    width: 1.05rem;
    height: 1.05rem;
    margin-top: .15rem;
    accent-color: #111;
  }

  a {
    color: #755a31;
    font-weight: 800;
  }

  small {
    display: block;
    margin-top: .35rem;
    color: var(--color-errorRed);
    font-size: .72rem;
  }
`;

export default TermsAcceptance;
